import { ApolloError } from '@apollo/client';
import type {
  Asset,
  CharacterRewards,
  Maybe,
} from '@monorepo/shared/src/graph/schema-generated-types-student';

export type RewardsStoreState = {
  charactersRewards: Maybe<CharacterRewards>[];
  instructions?: Asset;
  error: ApolloError | undefined;
  loading: boolean;
};

export type RewardsStoreDispatch = {
  handleUpdateSelectedReward: (rewardId: number) => Promise<CharacterRewards>;
};

export type RewardsStore = [RewardsStoreState, RewardsStoreDispatch];

export enum StickersCount {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

export const STICKER_INDEXES = Object.values(StickersCount)
  .filter((key) => isNaN(Number(StickersCount[key])))
  .map((value) => Number(value) - 1);

export type NewRewardData = {
  backgroundImage: string;
  matManImageSrc: string;
  title: string;
  summary: string;
};
